import { render, staticRenderFns } from "./addShop.vue?vue&type=template&id=1407abdf&scoped=true"
import script from "./addShop.vue?vue&type=script&lang=js"
export * from "./addShop.vue?vue&type=script&lang=js"
import style0 from "./addShop.vue?vue&type=style&index=0&id=1407abdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407abdf",
  null
  
)

export default component.exports